'use client';

import { BodyDefault } from '@terra/ui-design-system';

export function ListPageEmptyCell() {
  return <BodyDefault color="fg.neutral.subtle">-</BodyDefault>;
}
